/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UnintegratedFieldsSchemaEntry
 */
export interface UnintegratedFieldsSchemaEntry {
    /**
     * 
     * @type {string}
     * @memberof UnintegratedFieldsSchemaEntry
     */
    displayLabel: string;
    /**
     * 
     * @type {string}
     * @memberof UnintegratedFieldsSchemaEntry
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof UnintegratedFieldsSchemaEntry
     */
    required: boolean;
    /**
     * 
     * @type {UnintegratedFieldsSchemaEntryTypeEnum}
     * @memberof UnintegratedFieldsSchemaEntry
     */
    type: UnintegratedFieldsSchemaEntryTypeEnum;
}


/**
 * @export
 */
export const UnintegratedFieldsSchemaEntryTypeEnum = {
    TEXT_SINGLE_LINE: 'TEXT_SINGLE_LINE',
    TEXT_COMBO_BOX: 'TEXT_COMBO_BOX'
} as const;
export type UnintegratedFieldsSchemaEntryTypeEnum = typeof UnintegratedFieldsSchemaEntryTypeEnum[keyof typeof UnintegratedFieldsSchemaEntryTypeEnum];


/**
 * Check if a given object implements the UnintegratedFieldsSchemaEntry interface.
 */
export function instanceOfUnintegratedFieldsSchemaEntry(value: object): value is UnintegratedFieldsSchemaEntry {
    if (!('displayLabel' in value) || value['displayLabel'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('required' in value) || value['required'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function UnintegratedFieldsSchemaEntryFromJSON(json: any): UnintegratedFieldsSchemaEntry {
    return UnintegratedFieldsSchemaEntryFromJSONTyped(json, false);
}

export function UnintegratedFieldsSchemaEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnintegratedFieldsSchemaEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'displayLabel': json['displayLabel'],
        'name': json['name'],
        'required': json['required'],
        'type': json['type'],
    };
}

export function UnintegratedFieldsSchemaEntryToJSON(json: any): UnintegratedFieldsSchemaEntry {
    return UnintegratedFieldsSchemaEntryToJSONTyped(json, false);
}

export function UnintegratedFieldsSchemaEntryToJSONTyped(value?: UnintegratedFieldsSchemaEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'displayLabel': value['displayLabel'],
        'name': value['name'],
        'required': value['required'],
        'type': value['type'],
    };
}

